import { useCallback, useSyncExternalStore } from 'react';
import { userAuthorizationScopesStore } from './user-authorization-scopes-store';
import { useRuntime, ApplicationInsightsLogger } from '../../shell';
import { authorizationScopesFakes } from '../../fakes';
const useAuthorization = () => {
    const runtime = useRuntime();
    const authorizationScopes = useSyncExternalStore(userAuthorizationScopesStore.subscribe, userAuthorizationScopesStore.getSnapshot);
    if (runtime.fakes && authorizationScopes.authorizationScopes === undefined) {
        userAuthorizationScopesStore.setAuthorizationScopes(authorizationScopesFakes);
    }
    const permissions = authorizationScopes.authorizationScopes && authorizationScopes.selectedAuthorizationScopeId
        ? authorizationScopes.authorizationScopes[authorizationScopes.selectedAuthorizationScopeId]?.map(permission => permission.id)
        : undefined;
    const checkPermissions = useCallback((requiredPermissions, checkAllPermissions = false) => {
        const logger = new ApplicationInsightsLogger();
        const theUrl = window?.location?.href;
        if (!Array.isArray(requiredPermissions)) {
            requiredPermissions = [requiredPermissions];
        }
        let result;
        if (checkAllPermissions) {
            result = requiredPermissions.every(permission => permissions?.includes(permission));
        }
        else {
            result = requiredPermissions.some(permission => permissions?.includes(permission));
        }
        logger.information('Checking permissions', {
            requiredPermissions,
            permissions,
            checkAllPermissions,
            theUrl,
            result,
        });
        return result;
    }, [permissions]);
    return {
        authorizationScopeId: authorizationScopes.selectedAuthorizationScopeId,
        authorizationScopes: authorizationScopes.authorizationScopes,
        setAuthorizationScopeId: userAuthorizationScopesStore.setSelectedAuthorizationScopeId,
        setAuthorizationScopes: userAuthorizationScopesStore.setAuthorizationScopes,
        permissions: permissions,
        checkPermissions,
    };
};
function matchWildcardRule(str, rule) {
    const escapeRegex = str => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp('^' + rule.split('*').map(escapeRegex).join('.*') + '$').test(str);
}
export { matchWildcardRule, useAuthorization };
